// extracted by mini-css-extract-plugin
export default {"contact_section":"styles_contact_section__X3Z9f","heading_1":"styles_heading_1__VboW2","heading_2":"styles_heading_2__gP70t","desc":"styles_desc__ffCjM","btn":"styles_btn__MNQaA"};